// PowPowerOfPowerTask.js
// Potęga potęgi – (a^m)^n = a^{m·n}
// Wersja bez jedynek w wykładnikach, z szerszym zakresem: m ∈ {2..9}, n ∈ {2..9}

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const basePool = [2, 3, 4, 5, 6, 7, 8, 9];
  const a = pick(basePool);
  const m = pick([2, 3, 4, 5, 6, 7, 8, 9]); // bez 1, do 9
  const n = pick([2, 3, 4, 5, 6, 7, 8, 9]); // bez 1, do 9
  return { type: "PowPowerOfPowerTask", data: { a, m, n } };
}

// helper: ukrywa ^1 (nie wystąpi przy naszych zakresach, zostawione dla spójności)
const factorLatex = (a, exp) => (exp === 1 ? `${a}` : `${a}^{${exp}}`);

export function renderTask({ data }) {
  const { a, m, n } = data;
  const leftLatex = `\\big(${factorLatex(a, m)}\\big)^{${n}}`;
  return (
    <div style={{ marginBottom: "12px" }}>
      <div>
        Przedstaw w postaci jednej potęgi o podstawie{" "}
        <InlineMath math={`${a}`} />:
      </div>
      <BlockMath math={leftLatex} />
    </div>
  );
}


export function renderInput(task, userAnswer, onChange, disabled) {
  const handleChange = (ans) => onChange?.(ans);
  return (
    <div>
      <FractionInput
        value={userAnswer}
        onChange={handleChange}
        disabled={disabled}
        placeholder="np. 5^6"
        label=""
        powerPreview={true}
      />
      <div aria-hidden style={{ marginTop: "-16px" }} />
      <div aria-hidden style={{ height: "12px" }} />
    </div>
  );
}


// Parsowanie wpisu typu "2^7"
function parsePowerInput(raw) {
  if (!raw) return null;
  const match = raw.replace(/\s/g, "").match(/^(\d+)\^(\d+)$/);
  if (!match) return null;
  return { base: parseInt(match[1], 10), exp: parseInt(match[2], 10) };
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return false;
  const parsed = parsePowerInput(userAnswer.raw);
  if (!parsed) return false;
  const { a, m, n } = data;
  return parsed.base === a && parsed.exp === m * n;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw)
    return <i>(brak odpowiedzi)</i>;

  const raw = String(userAnswer.raw).trim().replace(/\s+/g, "");
  let latex = raw;
  const match = raw.match(/^(\d+)\^(\d+)$/);
  if (match) latex = `${match[1]}^{${match[2]}}`;

  return <InlineMath math={latex} />;
}


export function renderAnswer({ data }) {
  const { a, m, n } = data;
  return <InlineMath math={`${a}^{${m * n}}`} />;
}

export function renderExplanation({ data }) {
  const { a, m, n } = data;
  const leftLatex = `\\big(${factorLatex(a, m)}\\big)^{${n}}`;
  return (
    <div style={{ display: "grid", rowGap: "8px" }}>
      <p><strong>Krok 1:</strong> Potęga potęgi:</p>
      <BlockMath math={'(a^{m})^{n}=a^{m\\cdot n}'} />
      <p><strong>Krok 2:</strong> Podstaw i sprowadź do jednej potęgi:</p>
      <BlockMath math={`${leftLatex}\\;=\\;${a}^{${m}\\cdot${n}}\\;=\\;${a}^{${m * n}}`} />
    </div>
  );
}
